import { Routes } from "@angular/router";
import { IntroComponent } from "./components/intro/intro.component";
import { WindowCountComponent } from "./components/window-count/window-count.component";
import { AddressComponent } from "./components/address/address.component";
import { ExploreResourcesComponent } from "./components/explore-resources/explore-resources.component";
import { EnergyEfficiencyComponent } from "./components/energy-efficiency/energy-efficiency.component";
import { FinancingPlansComponent } from "./components/financing-plans/financing-plans.component";
import { FinancingEducationComponent } from "./components/financing-education/financing-education.component";
import { WindowIssuesComponent } from "./components/window-issues/window-issues.component";
import { DoNotServiceAreaComponent } from "./components/do-not-service-area/do-not-service-area.component";
import { HomeownerComponent } from "./components/homeowner/homeowner.component";
import { AdditionalCommentsComponent } from "./components/additional-comments/additional-comments.component";
import { InstallationProcessComponent } from './components/installation-process/installation-process.component';
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { TimeDateBookingComponent } from './components/time-date-booking/time-date-booking.component';
import { SourceTypeComponent } from "./components/source-type/source-type.component";
import { ProjectDetailsComponent } from './components/project-details/project-details.component';
import { ProjectDetailsSubmittedComponent } from './components/project-details-submitted/project-details-submitted.component';

export const routes: Routes = [
  {
    path: "",
    component: IntroComponent,
    title: "Home page",
    data: { embed: false }
  },
  {
    path: "embed-get-started",
    component: IntroComponent,
    title: "",
    data: { embed: true }
  },
  {
    path: "event",
    component: IntroComponent,
    title: "",
    data: { event: true }
  },
  {
    path: "field-agents",
    component: IntroComponent,
    title: "",
    data: { fieldAgents: true }
  },
  {
    path: "address",
    component: AddressComponent,
    title: "Address Info",
  },
  {
    path: "homeowner-list",
    component: HomeownerComponent,
    title: "Homeowner list",
  },
  {
    path: "window-count",
    component: WindowCountComponent,
    title: "Window count",
  },
  {
    path: "window-issues",
    component: WindowIssuesComponent,
    title: "Window issues",
  },
  {
    path: "source-type",
    component: SourceTypeComponent,
    title: "Source Type",
  },
  {
    path: "do-not-service-area",
    component: DoNotServiceAreaComponent,
    title: "Don't service area",
  },
  {
    path: "additional-comments",
    component: AdditionalCommentsComponent,
    title: "Additional Comments",
  },
  {
    path: "explore-resources",
    component: ExploreResourcesComponent,
    title: "Explore resources",
  },
  {
    path: "energy-efficiency",
    component: EnergyEfficiencyComponent,
    title: "Energy efficiency",
  },
  {
    path: "financing-plans",
    component: FinancingPlansComponent,
    title: "Financing plans",
  },
  {
    path: "financing-education",
    component: FinancingEducationComponent,
    title: "Financing education",
  },
  {
    path: "installation-process",
    component: InstallationProcessComponent,
    title: "Installation process",
  },
  {
    path: "time-date-booking",
    component: TimeDateBookingComponent,
    title: "Time and date booking",
  },
  {
    path: "project-details",
    component: ProjectDetailsComponent,
    title: "Project details",
  },
  {
    path: "project-details-submitted",
    component: ProjectDetailsSubmittedComponent,
    title: "Inside sales",
  },
  {
    path: "comments-submitted",
    component: ProjectDetailsSubmittedComponent,
    title: "Additional comments are submitted!",
    data: {
      commentsSubmitted: true
    }
  },
  {
    path: "**",
    pathMatch: "full",
    component: NotFoundComponent,
    title: "Not found",
  },
];
